import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ANavigationLink, ANavigationDropDown } from './';

export default class ANavigationLinkDropDown extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showDropDown: false };

		this.bindHandles();
	}

	bindHandles() {
		this.handleClick = this.handleClick.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleClick() {
		this.setState(prevState => ({ showDropDown: !prevState.showDropDown }));
	}

	handleKeyPress(event) {
		if (event.keyCode === 13) {
			this.handleClick();
		}
	}

	handleClickOutside() {
		this.setState({ showDropDown: false });
	}

	render() {
		let dropDown;

		if (this.state.showDropDown) {
			dropDown = (
				<ANavigationDropDown
					items={this.props.items}
					clickOutSide={this.handleClickOutside}
					onClick={this.props.onClick}
				/>
			);
		}

		return (
			<li
				className="a-navigation-link a-navigation--drop-down-wrapper"
				onClick={this.handleClick}
				onKeyDown={this.handleKeyPress}
				tabIndex="0"
				role="button"
			>
				<p className="nav-link">
					<FormattedMessage id={this.props.name} defaultMessage="" />
				</p>
				{dropDown}
			</li>
		);
	}
}

ANavigationLinkDropDown.propTypes = {
	name: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	onClick: PropTypes.func,
};

ANavigationLinkDropDown.defaultProps = {
	onClick: '',
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.navigation-link-drop-down.js